module.exports = __webpack_public_path__ + "static/media/model_result_positive.00957343.gif";